import {
  IGetGigsScheduleParams,
  IGetPrintScheduleParams,
  IScheduleGigDay,
} from '@src/models/GigSchedule'
import { AxiosService } from 'network/config/config'
import { Endpoints } from 'network/config/endpoints'
import { IPayload } from 'models/Global'

export class GigsScheduleApi {
  constructor(private axios: AxiosService) {}

  getGigsSchedule = async (params: IGetGigsScheduleParams) => {
    const response = await this.axios.get<IPayload<IScheduleGigDay[]>>(
      Endpoints.getGigsSchedule,
      params,
    )
    return response
  }

  postPrintSchedule = async (params: IGetPrintScheduleParams) => {
    const response = await this.axios.post<Blob>(
      Endpoints.postPrintSchedule,
      params,
      {
        responseType: 'blob',
      },
    )
    return response
  }
}
